import { useCallback, useState } from 'react';

const STORAGE_KEY = 'ep-nsmp-visao';

const lerVisao = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'completa' ? 'completa' : 'digitacao';
  } catch {
    return 'digitacao';
  }
};

const gravarVisao = (visao) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, visao);
  } catch {
    // a escolha vale na sessão mesmo sem persistir
  }
};

/** Visão preferida do digitador no modal da NSMP: 'digitacao' (padrão) ou 'completa'. */
export const useVisaoNsmp = () => {
  const [visao, setVisao] = useState(lerVisao);

  const alternar = useCallback(() => {
    setVisao((atual) => {
      const proxima = atual === 'digitacao' ? 'completa' : 'digitacao';
      gravarVisao(proxima);
      return proxima;
    });
  }, []);

  return { visao, alternar };
};

export default useVisaoNsmp;
